<script setup>
const emit = defineEmits(['update:modelValue'])

defineOptions({
  inheritAttrs: false
})

const props = defineProps({
  modelValue: {
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  isRequired: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
    <div class="form-row tw-mb-8 md:tw-mb-4">
        <label
            class="theme-label tw-text-left tw-text-14 tw-mb-1 md:tw-mb-2 tw-block"
            :for="props.name"
            v-text="props.label"
        >
        </label>

        <div class="tw-relative tw-w-full">
            <div class="tw-mb-2">
                <select
                    :id="props.name"
                    :name="props.name"
                    :value="props.modelValue"
                    @change="emit('update:modelValue', $event.target.value)"
                    :required="props.isRequired"
                    class="theme-border theme-bg tw-w-full tw-border-2 tw-rounded tw-py-3 tw-outline-none tw-transition-border tw-duration-500 md:tw-px-3.5"
                >
                    <option value=""></option>
                    <option
                        v-for="country in ['DE', 'CH', 'AT']"
                        :key="country"
                        :value="country"
                        v-t="`website.configurator.country.${country}`"

                    />
                </select>
            </div>
        </div>
    </div>
</template>